var _path, _path2, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgImgFullRepresentation(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50 100C77.6142 100 100 77.6142 100 50C100 22.3858 77.6142 0 50 0C22.3858 0 0 22.3858 0 50C0 77.6142 22.3858 100 50 100Z",
    fill: "#FFEADB"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_10359:22646",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M50 100C77.6142 100 100 77.6142 100 50C100 22.3858 77.6142 0 50 0C22.3858 0 0 22.3858 0 50C0 77.6142 22.3858 100 50 100Z",
    fill: "#FFEADB"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_10359:22646)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M59.4957 16.1465L52.9994 57H61.4994C73.2523 48.3935 74.0712 16.1465 59.4957 16.1465Z",
    fill: "#4B4A50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.4946 16.1474C57.5511 14.9674 47.294 11.9706 39.505 16.1474C29.9268 21.2835 23.4877 38.3061 36.9991 57C40.0184 57.0265 43.4989 57 43.4989 57L59.4946 16.1474Z",
    fill: "#4B4A50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.3338 53.1672H57.2734V50.5732H41.7261V53.1645C41.7261 55.703 41.7155 58.4623 39.505 60.1314V84.9996H49.4998C49.4998 84.9996 54.7333 84.9996 59.4945 84.9996V60.0926C57.3406 58.4193 57.3338 55.6839 57.3338 53.1672Z",
    fill: "#EFD1B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.5002 76.4122C46.1943 76.4122 42.0209 73.7108 39.9991 72.2954L42.837 105H58.3843V72.2954C55.865 74.8834 52.8061 76.4122 49.5002 76.4122Z",
    fill: "#A7163E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.3841 65.0112C58.7893 65.1218 59.1542 65.1807 59.4946 65.2093V60.0937C57.3408 58.4204 57.3339 55.6849 57.3339 53.1681L57.3324 53.1037V50.5098L45.0578 50.5742L41.7262 51.6847C43.9473 54.1836 50.7494 62.929 58.3841 65.0112Z",
    fill: "#D7AE88"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.0471 36.1358C65.0471 45.029 56.2025 56.1253 49.4998 56.1253C42.7971 56.1253 33.9525 45.029 33.9525 36.1358C33.9525 27.2426 40.9134 23.9199 49.4998 23.9199C58.0862 23.9199 65.0471 27.2426 65.0471 36.1358Z",
    fill: "#EFD1B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.7216 18.3672C51.0977 18.3672 49.0718 19.0682 47.4161 19.6825L47.2796 19.4777C47.2796 19.4777 47.051 19.6572 46.6555 19.9684C45.7345 20.3181 45.0586 20.5881 45.0586 20.5881L45.3183 21.0212C41.1033 24.3421 31.4864 31.9391 30.6216 32.804C29.5112 33.9145 37.2848 62.2473 37.2848 46.1303C37.2848 32.6653 44.7656 29.9986 51.7216 28.3619C54.8681 27.6216 55.7936 25.7707 56.1637 23.9199C56.5339 22.069 52.8322 18.3672 51.7216 18.3672Z",
    fill: "#4B4A50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.0524 25.0306C57.0883 32.3415 61.1603 35.65 64.9777 36.6217C67.0696 37.1542 66.1578 30.5833 66.1578 30.5833C66.1578 30.5833 63.1963 22.9946 62.8262 22.8097C62.4561 22.6245 59.4946 16.1465 59.4946 16.1465L52.8314 21.6992L55.0524 25.0306Z",
    fill: "#4B4A50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.2637 58.8013C39.1439 60.4911 36.861 61.679 32.176 61.679H31.7776C24.5145 61.679 18.6263 67.1482 18.6263 73.8949V101.669C18.6263 103.508 20.2321 105 22.213 105H56.7459L40.2637 58.8013Z",
    fill: "#E62645"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.7364 58.8013C59.8561 60.4911 62.139 61.679 66.824 61.679H67.2225C74.4856 61.679 80.3737 67.1482 80.3737 73.8949V101.669C80.3737 103.508 78.768 105 76.787 105H42.2542L58.7364 58.8013Z",
    fill: "#E62645"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40 21L36 12.3846C38 10.9487 41 7 50 7C59 7 62.3333 10.9487 64 12.3846L60 21C58.8333 20.2821 54.4 18.8462 50 18.8462C45.6 18.8462 41.5 20.2821 40 21Z",
    fill: "#E62645"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.0164 12.0164H50.9836V10.9836C50.9836 10.4401 50.5435 10 50 10C49.4565 10 49.0164 10.4401 49.0164 10.9836V12.0164H47.9836C47.4406 12.0164 47 12.4565 47 13C47 13.543 47.4406 13.9836 47.9836 13.9836H49.0164V15.0159C49.0164 15.5594 49.4565 16 50 16C50.5435 16 50.9836 15.5594 50.9836 15.0159V13.9831H52.0164C52.5594 13.9831 53 13.543 53 12.9995C53 12.4565 52.5594 12.0164 52.0164 12.0164Z",
    fill: "#EDEDEE"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgFullRepresentation);
export default __webpack_public_path__ + "static/media/imgFullRepresentation.d8ada40e8407a06c484311d82ba7c772.svg";
export { ForwardRef as ReactComponent };